import { Toolbar as StyleToolbar } from 'styles/toolbar'

export const Toolbar = StyleToolbar
